import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Userlist from "../../components/UserListComponent/Userlist";
import Courselist from "../../components/CourseListComponent/Courselist";
import { Box } from "@mui/system";
import Loader from "../Loader/Loader";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#F2F2F2",
  ...theme.typography.body2,
  //   padding: `calc(1em + ${theme.spacing(1)})`,
  padding: theme.spacing("70px 0 0 250px"),
  borderRadius: 0,
  boxShadow: "none !important",
  fontSize: 20,
  fontWeight: "bold",
  color: "#004A99",
  height: "100%",
}));

const CourseList = () => {
  const [courseList, setCourseList] = useState([]);
  const [render, setRender] = useState(false);
  const [pending, setPending] = useState(true);

  const getCourseList = async () => {
    console.log("api url", `api/v1/courses`);
    const request = {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        withCredentials: true,
        // Authorization: token,
      },
    };
    setPending(true);
    fetch(`api/v1/courses`, request)
      .then((response) => response.json())
      .then((res) => {
        console.log("user api res", res.courses);
        setCourseList(res.courses);
        setPending(false);
      })
      .catch((err) => console.log("err", err));
  };

  useEffect(() => {
    getCourseList();
  }, [render]);
  return (
    <>
      <Item>
        <Box sx={{ padding: "18px" }}>
          {!pending ? (
            <Courselist
              setRender={setRender}
              render={render}
              courses={courseList}
            />
          ) : (
            <Loader />
          )}
        </Box>
        {/* <Typography>User Lists</Typography> */}
      </Item>
    </>
  );
};

export default CourseList;
